import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const VENDOR_LABELS = {
  bundles: "Bundles",
  electronics: "Electronics",
  dyson: "Dyson",
  meta_glasses: "Meta Glasses",
  accessories: "Accessories",
  jewelry: "Jewelry",
  shoes: "Shoes",
  clothing: "Clothing",
  designer: "Designer",
  cologne: "Cologne",
};

export const VENDOR_SLUGS = [
  "bundles",
  "electronics",
  "dyson",
  "meta_glasses",
  "accessories",
  "jewelry",
  "shoes",
  "clothing",
  "designer",
  "cologne",
];

export const vendorLabel = (slug) => VENDOR_LABELS[slug] || slug;

export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);
